import React from 'react';
import AltIso from 'alt/utils/AltIso';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';
import CurrentUserActions from '../actions/CurrentUserActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import ForgotPasswordChangeForm from '../forms/ForgotPasswordChangeForm';


@AltIso.define((props) => {
    return SeoActions.pushTitle('Forgot password');
})
class ResetPasswordView extends React.Component {
    doChangePassword(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        const token = this.props.params.token;


        //var email = React.findDOMNode(this.refs.email).value.trim();
        //var password = React.findDOMNode(this.refs.password).value.trim();

        //console.log(email, password);

        if (errors)  {
            CurrentUserActions.failResetPassword(errors);
        }

        if (data) {
            // Try to log the user in
            CurrentUserStore.changeUserForgottenPassword({password: data.password, password_confirm: data.password_confirm, uid_and_token_b64: token});
        }
    }

    render() {
        return (
            <div className="view-login view-forgotpassword maxwidth-wrapper">
                <div className="view-content">
                    <img className="site-logo" src={require('../styles/images/site-logo.svg')} alt="Gigpanel" />

                    <form className="whitebox login-form" onSubmit={this.doChangePassword.bind(this)}>
                        <h1>Account recovery</h1>

                        <ForgotPasswordChangeForm ref="form" originalFormData={this.props.user.retrievePasswordError.resetPasswordData || {}} retrievePasswordError={this.props.user.retrievePasswordError} />

                        <button className="btn btn-orange form-control-submit">Change password</button>
                    </form>

                </div>
            </div>
        );
    }
}

export default ResetPasswordView;



/** WEBPACK FOOTER **
 ** ./app/src/views/ResetPasswordView.js
 **/